export default {
  DISABLED: 'disabled',
  MANDATORY: 'mandatory',
  OPTIONAL: 'optional',
};
